enum SortDirection {
  Ascending = 1,
  Descending = -1,
}

export default SortDirection;
